import { NavigateFunction } from 'react-router'
import FFGFormNavigation from 'components/FormNavigation/components/FFGFormNavigation'
import SmavaFormNavigation from 'components/FormNavigation/components/SmavaFormNavigation'
import FormNavigationEditPage from 'components/FormNavigation/components/FormNavigationEditPage'
import useStore from 'stores/utils/hooks/useStore'
import { observer } from 'mobx-react'
import { RCE_EDIT_PAGE_NAMES } from 'utils/pages'
import useTenant from 'hooks/useTenant'

interface Props {
  onBack?: () => void
  onNext: () => void
  navigate: NavigateFunction
}

const FormNavigationSwitcher = observer((props: Props) => {
  const sharedProps = {
    onNext: props.onNext,
    onBack: props.onBack,
    navigate: props.navigate
  }

  const {
    page: { config },
    navigation: { currentPageInSession }
  } = useStore()

  const { isSmava } = useTenant()
  const isRCEEditPage =
    config.separateEditPage &&
    RCE_EDIT_PAGE_NAMES.includes(currentPageInSession || '')

  if (isRCEEditPage && currentPageInSession) {
    return <FormNavigationEditPage {...sharedProps} />
  }

  if (isSmava) {
    return <SmavaFormNavigation {...sharedProps} />
  }

  return <FFGFormNavigation {...sharedProps} />
})

export { FormNavigationSwitcher }
